import loaderStore from '@src/application/store/loader-store.js';

export function isLoading() {
    return loaderStore.openLoaders.data > 0 || loaderStore.deploying.data > 0;
}

export function setLoading(isLoading: boolean) {
    if (isLoading) {
        loaderStore.openLoaders.data++;
        return;
    }
    if (loaderStore.openLoaders.data === 0) {
        return;
    }
    loaderStore.openLoaders.data--;
}

export function openLoader(message: string|null = null) {
    setLoading(true);
    loaderStore.message.data = message;
}

export function closeLoader() {
    setLoading(false);
    loaderStore.message.data = null;
}
